/**
 * Anonymous cookie-banner counts, sent whatever the visitor decides. The
 * marketing site's Worker records them (spatius-site
 * worker/lib/consent-events.ts) with the country of the request; the body holds
 * the surface, action and locale only and nothing is stored in the browser.
 */
export type ConsentEventAction = 'shown' | 'accepted' | 'declined'

const ENDPOINT = 'https://www.spatius.ai/api/consent-events'
// Test and preview deployments never count.
const REPORTING_HOST = 'app.spatius.ai'

let shownReported = false

/** `shown` is sent once per page load in which the banner appears. */
export function reportConsentEvent(action: ConsentEventAction, locale: string): void {
  if (typeof window === 'undefined' || window.location.hostname !== REPORTING_HOST)
    return
  if (action === 'shown') {
    if (shownReported)
      return
    shownReported = true
  }
  try {
    navigator.sendBeacon?.(ENDPOINT, JSON.stringify({
      surface: 'studio',
      action,
      locale: locale.startsWith('zh') ? 'zh' : 'en',
    }))
  }
  catch {
    // Counting must never break the banner.
  }
}
